import React from 'react'
import RelevantEdit from "./RelevantEdit";
import {Button, Popconfirm} from "antd";
import {deleteRelevantPerson} from "../../services/serviceRelevantPerson";


const RelevantActions = ({record, updater}) => {

    const handleDeleteClick = () => {
        deleteRelevantPerson(record.id)
            .then(() => updater())
    }

    return(
        <React.Fragment>
            <RelevantEdit record={record} updater={updater} />
            <Popconfirm title={'Bu işlemi Gerçekleştirmek İstediğinize Emin misiniz ?'}
                        okText={'SİL'}
                        cancelText={'VAZGEÇ'}
                        okButtonProps={{type: 'danger'}}
                        onConfirm={handleDeleteClick}
            >
                <Button
                    type={'link'}
                    danger
                >
                    Sil
                </Button>
            </Popconfirm>
        </React.Fragment>
    )
}
export default RelevantActions